<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="1rem" fxFill>
  <div style="font-size: 3.5rem; font-weight: 800">404</div>

  <div>The page you're looking for cannot be found</div>
</div>
